<template>
    <div class="rn-card box-card-style-default"
         :class="{'card-list-view': blogPostStyle === 'list'}">
        <div class="inner">
            <div class="thumbnail">
                <router-link class="image" :to="`/portfolio-details/${portfolio.id}`">
                    <img class="w-100" :src="getImgUrl(portfolio.portfolioImage)" :alt="portfolio.title">
                </router-link>
            </div>
            <div class="content">
                <ul v-if="blogPostStyle === 'card'" class="rn-meta-list">
                    <li>
                        <router-link :to="''">
                            {{ portfolio.subtitle }}
                        </router-link>
                    </li>
                    <li class="separator">/</li>
                    <li>{{ portfolio.date }}</li> 
                </ul>
                <h4 class="title">
                    <router-link :to="`/portfolio-details/${portfolio.id}`">
                        {{ portfolio.title }}
                    </router-link>
                </h4>
                <ul v-if="blogPostStyle === 'list'" class="rn-meta-list">
                    <li>
                        <router-link :to="''">
                            {{ portfolio.subtitle }}
                        </router-link>
                    </li>
                    <li class="separator">/</li>
                    <li>{{ portfolio.date }}</li>
                </ul>
                <p v-if="blogPostStyle === 'list'" class="descriptiion">
                    {{ portfolio.title }}
                </p>
            </div> 
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BlogPost',
        props: {
            portfolio: {},
            blogPostStyle: {
                type: String,
                default: 'card'
            }
        }
    }
</script>